import { asyncRouterMap } from '../router';
import asyncRoutes from '../router/asyncRoutes';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import { getToken } from '@/utils/auth'; // 验权
import { getAuthRoute } from '../utils/route';

const configRoutePermission = (
  router,
  store,
  allAasyncRouterMap,
  whiteList
) => {
  NProgress.configure({ showSpinner: false }); // NProgress Configuration

  const getRouteAdd = () => {
    let allRoute = store.getters.asyncRoutes;
    let asyncRouters = getAuthRoute(allAasyncRouterMap, allRoute);
    let indexPage = asyncRouters.find(item => item.path === '/');
    if (!indexPage) {
      router.addRoutes([asyncRoutes[0]]); // 添加首页
    }

    router.addRoutes(asyncRouters); // 动态添加可访问路由表
    router.addRoutes(asyncRouterMap);
  };

  router.beforeEach((to, from, next) => {
    NProgress.start(); // 进度条Progress
    if (getToken()) {
      if (to.path === '/login') {
        next({ path: '/' });
        NProgress.done();
      } else {
        if (store.getters.isRouteDone) {
          next(); //
        } else {
          let addRoute = store.getters.asyncRoutes;
          if (addRoute && addRoute.length) {
            getRouteAdd();
            store.dispatch('GenerateRoutes');
            next({ ...to, replace: true });
          } else {
            store
              .dispatch('TokenLogin', {
                data: { token: getToken() },
              })
              .then(() => {
                getRouteAdd();
                store.dispatch('GenerateRoutes');
                next({ ...to, replace: true });
              })
              .catch(err => {
                console.error(err);
                store.dispatch('FedLogOut').then(() => {
                  next({ path: '/login' });
                });
              });
          }
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        store.dispatch('FedLogOut').then(() => {
          next({ path: '/login' });
          NProgress.done();
        });
      }
    }
  });

  router.afterEach(() => {
    NProgress.done(); // 结束Progress
  });
};

export default configRoutePermission;
